<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>

          <b-navbar-brand center
            >Freight Export
            <!-- <Add-Message  :fk_all_module_id="ffExoprtDetail.allModuleId" :fk_client_id="ffExoprtDetail.PODLocationId" :fk_pod_id="ffExoprtDetail.clientId"/> -->
          </b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button-group size="sm">
              <b-button
                :disabled="bookPageId == '0' ? true : false"
                @click="gotToPage('BOOK')"
                :variant="bookPageId == '0' ? '' : 'success'"
                >Booking</b-button
              >
              <b-button
                :disabled="execPageId == '0' ? true : false"
                @click="gotToPage('EXEC')"
                :variant="execPageId == '0' ? '' : 'success'"
                >Execution</b-button
              >
              <b-button
                :disabled="vgmPageId == '1' || vgmBy == 'SHIPPER' ? true : false"
                @click="gotToPage('VGM')"
                :variant="vgmPageId == '1' || vgmBy == 'SHIPPER' ? '' : 'success'"
                >VGM</b-button
              >
              <b-button
                :disabled="handoverPageId == '0' ? true : false"
                @click="gotToPage('HAND')"
                :variant="handoverPageId == '0' ? '' : 'success'"
                >Handover & Rail-Out</b-button
              >
              <b-button
                :disabled="sailPageId == '0' ? true : false"
                @click="gotToPage('SAIL')"
                :variant="sailPageId == '0' ? '' : 'success'"
                >Sail & FPOD</b-button
              >
              <b-button
                :disabled="ladingPageId == '0' ? true : false"
                @click="gotToPage('LADING')"
                :variant="ladingPageId == '0' ? '' : 'success'"
                >Bill Of Lading</b-button
              >

              <!--<b-button disabled>BL</b-button> -->
            </b-button-group>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          v-if="ffExoprtDetail.allModuleId>0"
          :allModuleIdBanner="
            this.ffExoprtDetail.allModuleId ? this.ffExoprtDetail.allModuleId : ''
          "
          :jobSeriesBanner="
            this.ffExoprtDetail.ffExportFclSeries
              ? this.ffExoprtDetail.ffExportFclSeries
              : ''
          "
          :bannerClientName="getCLientData.length > 0 ? getCLientData[0].clientName : ''"
          :trackingId="trackingId != '' ? trackingId : ''"
          iconId="fa fa-ship"
          :prbr_id="ffExoprtDetail.prbr_id"
        />
        <!-- <b-alert style="background-color: #002b49 !important;padding: 0.45rem 1.00rem  !important;margin-bottom: 3px !important;" show>INT/EXP/NOA/4787/2021-2022</b-alert> -->
        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ffExoprtDetail.ffExportFclId!=''"
                  @click="addMessage"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab">
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->

            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ffExoprtDetail.ffExportFclId!=''"
                  @click="addStatus"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->
            <!-- <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="10">
            <label style="margin-top:15px">
              <u>Job Type</u>
            </label>
          </md-layout>

          <md-layout
            v-for="(segmentNameArray, index) in showSegmentArray"
            :key="index"
            :md-flex="segmentNameArray.flex"
          >
            <md-checkbox
              :disabled="ffExoprtDetail.allModuleId!='0'?true:false"
              v-model="ffExoprtDetail.jobType[index]"
              class="md-primary"
              :md-value="segmentNameArray.value"
              :name="'jobType'+(index+1)"
              :id="'jobType'+(index+1)"
              @change="jobTypeSelect(segmentNameArray.value,index)"
            >{{segmentNameArray.show}}</md-checkbox>
          </md-layout>
        </md-layout>
            <hr class="hr-border" />-->
            <StatusAlerts :SUBS_alerts="SUBSAlerts" />
            <h5 style="color: red">
              Status Verbose : {{ ffExoprtDetail.status_verbose }}
            </h5>
            <h6 style="color: red">
              Event MSG : {{ ffExoprtDetail.sub_noti_event_message }}
            </h6>
            <md-layout md-gutter>
              <md-layout md-flex="20" class="pl-2 pr-2">
                <label for="containerInfo">FF Activity Type</label>
                <model-list-select
                  isDisabled
                  :list="containerInfoList"
                  v-model="ffExoprtDetail.containerInfo"
                  option-value="containerInfoVal"
                  option-text="containerInfoText"
                  placeholder="Select Container Load"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <md-layout md-flex="30" class="pl-2 pr-2">
                <label for="stuffingType">Stuffing Type *</label>
                <model-list-select
                  isDisabled
                  :list="stuffingTypeList"
                  v-model="ffExoprtDetail.stuffingType"
                  option-value="stuffingTypeVal"
                  option-text="stuffingTypeText"
                  placeholder="Select Stuffing Type"
                ></model-list-select>
                <!-- :isDisabled="ffExoprtDetail.containerInfo=='lcl'?true:ExecutionDisable==''?false:true" -->
                <span class="error" v-if="!ffExoprtDetail.stuffingType">{{
                  ffExporterrorList.stuffingType
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="15">
            <label for="shipmentType">Shipping Type</label>
            <model-list-select
              :list="shipmentTypeList"
              isDisabled
              @change="methodsHere()"
              v-model="ffExoprtDetail.shipmentType"
              option-value="shipmentTypeVal"
              option-text="shipmentTypeText"
              placeholder="Select Shipment Type"
            ></model-list-select>
              </md-layout>-->
              <!-- <md-layout md-flex="10">
            <label for="transportType">Export</label>
            <model-list-select
              :list="transportTypeList"
              isDisabled
              v-model="ffExoprtDetail.transportType"
              option-value="transportTypeVal"
              option-text="transportTypeText"
              placeholder="Select Transport Type"
            ></model-list-select>
              </md-layout>-->
              <!-- <md-layout
                md-flex="5"
                v-if="ffExoprtDetail.containerInfo == 'fcl'"
              ></md-layout> -->

              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.containerInfo == 'fcl'"
              >
                <label for="shippingId">Shipping Line Name *</label>
                <model-list-select
                  isDisabled
                  :list="shippingList"
                  v-model="ffExoprtDetail.shippingId"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.shippingId">{{
                  shippingIdError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="clientId">Shipper Name *</label>

                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.clientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Shipper Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.clientId">{{
                  ffExporterrorList.clientId
                }}</span>
              </md-layout>

              <!-- <md-layout md-flex="5"></md-layout> -->

              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="shipmentType">Source Of Booking</label>
                <!-- shipType is for source of booking -->
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="shipTypeList"
                  v-model="ffExoprtDetail.shipType"
                  option-value="shipTypeVal"
                  option-text="shipTypeText"
                  placeholder="Select Source Of Booking "
                ></model-list-select>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <h4 style="margin:0px" class="showMoreData" @click="addNew">Add New Client</h4>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter v-if="ffExoprtDetail.containerInfo == 'lcl'">
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="agentName">CoLoader Name</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="getColoaderName"
                  v-model="ffExoprtDetail.coloaderName"
                  option-value="agntColoaderId"
                  option-text="coLoaderName"
                  placeholder="Select Coloader Name"
                ></model-list-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.shipType != ''"
              >
                <label for="sourceOriginclientId">Booking Party</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.sourceOriginclientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Booking Party"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout
                md-flex="25"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.shipType == 'Destination'"
              >
                <label for="agentName">Agent Name</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="getagentName"
                  v-model="ffExoprtDetail.agentName"
                  option-value="agntColoaderId"
                  option-text="agentName"
                  placeholder="Select Agent Name"
                ></model-list-select>
              </md-layout>

              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout
                md-flex="20"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.shipType == 'Destination'"
              >
                <md-layout md-flex="100">
                  <label>Buyer Name</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="buyer"
                    name="buyer"
                    v-model="ffExoprtDetail.buyer"
                  ></b-form-input>
                </md-layout>
              </md-layout>

              <!-- <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Origin'">
            <md-layout md-flex="100">
              <label>Enter Buying House</label>
              <b-form-input :formatter="capitalizeAll"
                id="buyingHouse"
                name="buyingHouse"
                v-model="ffExoprtDetail.buyingHouse"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Origin'">
            <md-layout md-flex="100">
              <label>Other Specify</label>
              <b-form-input :formatter="capitalizeAll"
                id="otherSpecify"
                name="otherSpecify"
                v-model="ffExoprtDetail.otherSpecify"
              ></b-form-input>
            </md-layout>
              </md-layout>-->
            </md-layout>
            <md-layout v-if="newJobType.indexOf('CC') >= 0" md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="ccType">CC Type</label>
                <model-list-select
                  :disabled="viewPagePref==1"
                  :list="cctypeList"
                  v-model="ffExoprtDetail.ccType"
                  option-value="ccTypeVal"
                  option-text="ccTypeTxt"
                  placeholder="Select CC Type"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.ccType == 'Outsourced'"
              >
                <md-layout md-flex="100">
                  <label>CHA Name</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="ccCha"
                    name="ccCha"
                    v-model="ffExoprtDetail.ccCha"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="100" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Commodity Remarks</label>
                  <b-form-textarea
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="ccCha"
                    disabledCommodity
                    Type
                    name="ccCha"
                    v-model="ffExoprtDetail.commodityRemarks"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="autoCommodity">HSN-Commodity Code *</label>
                <!-- <model-list-select
                  @searchchange="getCommodityList($event, 'getCommodityData')"
                  :list="commodityList"
                  v-model="ffExoprtDetail.commodityId"
                  option-value="commodityId"
                  option-text="itemDescription"
                  placeholder="Select Commodity"
                ></model-list-select> -->

                <model-list-select
                  :isDisabled="viewPagePref==1"
                  @searchchange="getCommodityList($event, 'getCommodityData')"
                  :list="commodityList"
                  v-model="ffExoprtDetail.commodityId"
                  option-value="commodityId"
                  option-text="itemHSNCode"
                  placeholder="Select Commodity"
                ></model-list-select
                ><span class="error" v-if="!ffExoprtDetail.commodityId">{{
                  ffExportCommodityerrorList.commodityId
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2 justify-content-end">
                <b-button
                  :disabled="viewPagePref==1"
                  variant="primary"
                  @click="openCommodityModal()"
                  id="addButtonLoader"
                  size="sm"
                  style="margin-top: 40px"
                  >Add</b-button
                >
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="commodityType">Commodity Type</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="commodityTypeName"
                  v-model="ffExoprtDetail.commodityType"
                  option-value="commodityTypeVal"
                  option-text="commodityTypeText"
                  placeholder="Select Commodity Type"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label for="itemDescription">Item Description</label>

              <b-form-textarea :formatter="capitalizeAll"
                id="itemDescription"
                name="itemDescription"
                disabled
                v-model="ffExoprtDetail.itemDescription"
              ></b-form-textarea>
            </md-layout>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Hazardous'">
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>IMDG Class</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="IMDGClass"
                    name="IMDGClass"
                    v-model="ffExoprtDetail.IMDGClass"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>UN Number</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="UNNumber"
                    name="UNNumber"
                    v-model="ffExoprtDetail.UNNumber"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="20" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Packing Code</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="packingCode"
                    name="packingCode"
                    v-model="ffExoprtDetail.packingCode"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Reefer'">
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Temperature Req(Degree Celsius)</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="temperatureRequired"
                    name="temperatureRequired"
                    v-model="ffExoprtDetail.temperatureRequired"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Others'">
              <md-layout md-flex="100" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Specific Detail if any..!</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="otherComodity"
                    name="otherComodity"
                    v-model="ffExoprtDetail.otherComodity"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="PORlocationId">Place of Receipt *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'Sea_Port,Icd', 'IcdPOrtList')"
                  @searchchange="getLocationList($event, 'Sea_Port,Icd', 'IcdPOrtList')"
                  :list="IcdPOrtListNew"
                  v-model="ffExoprtDetail.PORlocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select Place of Receipt"
                ></model-list-select>
                <!-- :isDisabled="ExecutionDisable==''?false:true" -->
                <span class="error" v-if="!ffExoprtDetail.PORlocationId">{{
                  ffExporterrorList.PORlocationId
                }}</span>
              </md-layout>

              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="LPlocationId">Load Port Name *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'Sea_Port', 'PortLoadList')"
                  @searchchange="getLocationList($event, 'Sea_Port', 'PortLoadList')"
                  :list="PortLoadList"
                  v-model="ffExoprtDetail.LPlocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select Load Port Name"
                  :isError="ffExoprtDetail.portType == 'Icd' ? false : true"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.LPlocationId">{{
                  ffExporterrorList.LPlocationId
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="PODLocationId">Port of Discharge *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'Sea_Port', 'getPortDischargeList')"
                  @searchchange="
                    getLocationList($event, 'Sea_Port', 'getPortDischargeList')
                  "
                  :list="PortDischargeList"
                  v-model="ffExoprtDetail.PODLocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POD"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.PODLocationId">{{
                  ffExporterrorList.PODLocationId
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="finalPlaceLocationId">Final Place of Delivery *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'All', 'finalAllPlaceData')"
                  @searchchange="getLocationList($event, 'All', 'finalAllPlaceData')"
                  :list="finalAllPlaceData"
                  v-model="ffExoprtDetail.finalPlaceLocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select FPOD"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.finalPlaceLocationId">{{
                  ffExporterrorList.finalPlaceLocationId
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.portType == 'Icd'"
              >
                <label for="pdaDetail">PDA Details</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="pdaDetailList"
                  v-model="ffExoprtDetail.pdaDetail"
                  option-value="pdaDetailsVal"
                  option-text="pdaDetailsText"
                  placeholder="Select PDA "
                ></model-list-select>
              </md-layout>
              <!-- <md-layout
                md-flex="5"
                v-if="ffExoprtDetail.portType == 'Icd'"
              ></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="deliveryMode">Destination Delivery Mode</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="deliveryModeList"
                  v-model="ffExoprtDetail.deliveryMode"
                  option-value="deliveryModeVal"
                  option-text="deliveryModeText"
                  placeholder="Select Delivery Mode"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                <model-list-select
                  :isDisabled="viewPagePref==1"
                  :list="deliveryTermsList"
                  v-model="ffExoprtDetail.deliveryTerms"
                  option-value="deliveryTermsVal"
                  option-text="deliveryTermsText"
                  placeholder="Select Delivery Terms"
                ></model-list-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Free Time At Origin(In Days)</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="freeTimeAtOrigin"
                    name="freeTimeAtOrigin"
                    v-model="ffExoprtDetail.freeTimeAtOrigin"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Free Time At Destination(In Days)</label>
                  <b-form-input
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="freeTimeAtDestination"
                    name="freeTimeAtDestination"
                    v-model="ffExoprtDetail.freeTimeAtDestination"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              v-if="specialInstruction != null && specialInstruction != ''"
            >
              <md-layout md-flex="100" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Special Instruction</label>
                  <b-form-textarea
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="remark"
                    name="remark"
                    v-model="specialInstruction"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="mt-3 pl-2 pr-2">
              <md-layout md-flex="20">
                <h5>
                  <b-badge>Additional Task</b-badge>
                </h5>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="pl-2 pr-2">
              <md-layout
                v-for="(otherServiceNameArray, index) in showOtherServiceArray"
                :key="index"
                md-flex="25"
              >
                <!-- :md-flex="otherServiceNameArray.flex" -->
                <md-checkbox
                  :disabled="viewPagePref==1"
                  v-model="ffExoprtDetail.otherServices[index]"
                  class="md-primary"
                  :md-value="otherServiceNameArray.value"
                  :name="'otherServices' + (index + 1)"
                  :id="'otherServices' + (index + 1)"
                  @change="
                    otherServiceNameArraySelect(otherServiceNameArray.value, index)
                  "
                  >{{ otherServiceNameArray.show }}</md-checkbox
                >
              </md-layout>
            </md-layout>

            <!-- <md-layout md-gutter>
             
              <md-layout md-flex="15">
        
                <label style="margin-top:16px">
                  <b>
                    <u>More Additional Task</u>
                  </b>
                </label>
              </md-layout>
            </md-layout> -->
            <!-- <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <md-input-container style="background:white !important">
                  <md-select
                    placeholder="Click For More Additional Task"
                    name="additionalMoreTask"
                    id="additionalMoreTask"
                    multiple
                    v-model="ffExoprtDetail.additionalMoreTask"
                    @change="showMultiple"
                  >
                    <md-option
                      style="background:white !important"
                      v-for="(AdditionalMoreArray,index) in showAdditionalMoreTaskArray"
                      :key="index"
                      :value="AdditionalMoreArray"
                    >{{AdditionalMoreArray.show}}</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
            </md-layout> -->
            <!-- <md-layout md-gutter v-if="showAdd" class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Specify Additional Task</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="specificAdditionalTask"
                    name="specificAdditionalTask"
                    v-model="ffExoprtDetail.specificAdditionalTask"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout> -->

            <!-- <hr class="hr-border" v-if="ExecutionDisable==''">
        <md-layout md-gutter class="gutr" v-if="ExecutionDisable==''">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <label>
              <b>
                <u>
                  Container Details
                  <span
                    class="error"
                    v-if="commodityArray.length == 0"
                  >{{errorAtleastOne}}</span>
                </u>
              </b>
            </label>
          </md-layout>
        </md-layout>
        <md-layout md-gutter v-if="ExecutionDisable==''">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15" class="gutr">
            <md-layout md-flex="100">
              <label>No. of Containers</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="noOfContainer"
                name="noOfContainer"
                v-model="containerModal.noOfContainer"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!containerModal.noOfContainer">{{noOfContainerError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="35" class="gutr">
            <label for="containerTypeId">Container Type/Size</label>
            <model-list-select
              :list="ContainerTypeList"
              v-model="containerModal.containerTypeId"
              option-value="containerTypeId"
              option-text="containerType"
              placeholder="Select Container Type/Size"
            ></model-list-select>
            <span class="error" v-if="!containerModal.containerTypeId">{{containerTypeIdError}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="25">
            <md-button
              style="margin-top:28px"
              :Disabled="ExecutionDisable==''?false:true"
              class="md-raised md-primary md-button-color heght-1px"
              id="addButtonLoaderC"
              @click="addFFContainers"
            >Add Container</md-button>
            <md-spinner md-indeterminate id="loaderC" style="display:none"></md-spinner>
          </md-layout>
            </md-layout>-->

            <!-- <h5 class="box-title mt-4">
                  <b-badge>Container Details</b-badge>
                </h5>
          
                <table  v-if="allContainers.length>0" id="FreghtContaner" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.no</th>
                      <th>ContainerType</th>
                      <th>No of Container</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item1,index) in allContainers" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item1.containerType}}</td>
                      <td>{{item1.noofContainer}}</td>
                    
                    </tr>
                  </tbody>
                </table> -->

            <md-layout md-gutter>
              <md-layout md-flex="100" class="pr-2 pl-2">
                <md-layout md-flex="100">
                  <label>Remarks</label>
                  <b-form-textarea
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    id="remark"
                    name="remark"
                    v-model="ffExoprtDetail.remark"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout class="justify-content-center mt-3">
                <b-button variant="primary" id="addButtonLoaderS" @click="addFFExport"
                  >Save & Proceed to Booking</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderS"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>

            <b-col lg="12">
              <span class="error pull-right" v-if="ffExoprtDetail.FFExportCreated">
                <b> {{ ffExoprtDetail.FFExportCreated }}</b>
              </span>
            </b-col>

            <b-col lg="12">
              <span class="error pull-right" v-if="ffExoprtDetail.FFExportUpdated">
                <b> {{ ffExoprtDetail.FFExportUpdated }}</b>
              </span>
            </b-col>

            <!-- <b-col lg="12"> {{ ffExoprtDetail }} </b-col> -->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <!-- Commodity Modal Added By Priyanshu Singh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Commodity-modal"
      hide-footer
      title="Add Commodity"
    >
      <b-row class="justify-content-center">
        <b-col md="4">
          <label>Item Name <span class="error">*</span></label>
          <b-form-input
            size="sm"
            :formatter="capitalizeAll"
            id="itemName"
            name="itemName"
            v-model="commodityModal.itemName"
          ></b-form-input>
          <span class="error" v-if="!commodityModal.itemName">{{
            errorList.itemName
          }}</span>
        </b-col>
        <b-col md="4">
          <label>HSN Code <span class="error">*</span></label>
          <b-form-input
            size="sm"
            :formatter="capitalizeAll"
            id="hsnCode"
            name="hsnCode"
            v-model="commodityModal.hsnCode"
          ></b-form-input>
          <span class="error" v-if="!commodityModal.hsnCode">{{
            errorList.hsnCode
          }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3 text-center">
          <b-button
            variant="outline-primary"
            @click="addCommodity"
            id="addButtonLoader"
            size="sm"
            >Save</b-button
          >
          <b-button
            variant="outline-danger"
            class="ml-2"
            size="sm"
            @click="hideCommodityModal"
            >Close</b-button
          >
          <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Commodity Modal Added By Priyanshu Singh Start -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="delete"
      @close="deleteCon"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11212"
      @close="onClose11212"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import BannerComponent from "../allModuleForm/bannerComponent.vue";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";

// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
  GlobalGetCommodity2,
} from "../../helper/collection";
import AddMessage from "../allModuleForm/addMessage.vue";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";
import StatusAlerts from "../ocean-insights/StatusAlerts.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") ||
      globalPermissionStatus("Overseas Agent Assignments")
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ffExportFcl");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    // CommodityAll: {
    //   handler: function(newVal, oldVal) {
    //     this.CommodityCallback(newVal);
    //   },
    //   deep: true
    // },
    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        // if (
        //   newVal.hasOwnProperty("PORlocationId") &&
        //   newVal.PORlocationId != ""
        // ) {
        //   let array = this.IcdPOrtList.filter(x => {
        //     return x.pickupId == newVal.PORlocationId;
        //   })[0];
        //   console.log(array, newVal.PORlocationId);

        //   this.ffExoprtDetail.portType = array.locationType;
        //   if (array.locationType != "Icd") {
        //     this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
        //     this.PortLoadList = this.IcdPOrtList;
        //   }

        //   this.deliveryTermsName[1].deliveryTermsText =
        //     "FOB_POR_ " + array.pickupLocation;
        // }

        // if (newVal.LPlocationId != "") {
        //   let array1 = this.PortLoadList.filter(x => {
        //     return x.pickupId == newVal.LPlocationId;
        //   })[0];
        //   this.deliveryTermsName[2].deliveryTermsText =
        //     "FOB_LoadPort_ " + array1.mainLocation;
        // }

        if (newVal.containerInfo == "lcl") {
          this.ffExoprtDetail.stuffingType = "warehouseStuffing";
        }
        if (newVal.PODLocationId != "") {
          let arraySI = this.PortDischargeList.filter((x) => {
            return x.pickupId == newVal.PODLocationId;
          });

          if (arraySI.length > 0) {
            this.specialInstruction = arraySI[0].specialInstruction;
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      // Added vy Priyanshu Singh Start
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: [
        "Please Enter ItemName",
        // "Please Enter HSNCode",
      ],
      errorList: {
        itemName: "",
        // hsnCode: "",
      },
      // Added vy Priyanshu Singh End
      isLoading: false,
      trackingId: "",
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      getColoaderName: [],
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory Stuffing",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse Stuffing",
        },
      ],

      cctypeList: [
        {
          ccTypeVal: "Pridel",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "Outsourced",
          ccTypeTxt: "Outsourced",
        },
      ],
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      commodityTypeName_bak: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "Hazardous",
        },
        {
          commodityTypeVal: "Non_Hazardous",
          commodityTypeText: "Non Hazardous",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "Reefer",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "Others",
        },
      ],

      containerInfoName: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "Sea_Port",
          deliveryModeText: "Sea Port",
        },
        {
          deliveryModeVal: "ICD",
          deliveryModeText: "ICD",
        },
        {
          deliveryModeVal: "DOOR",
          deliveryModeText: "DOOR",
        },
      ],

      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],

      deliveryTermsName_bak: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],
      pdaDetailsName: [
        {
          pdaDetailsVal: "Pridel",
          pdaDetailsText: "Pridel",
        },
        {
          pdaDetailsVal: "Shipper",
          pdaDetailsText: "Shipper",
        },
        {
          pdaDetailsVal: "Liner",
          pdaDetailsText: "Liner",
        },
        {
          pdaDetailsVal: "NA",
          pdaDetailsText: "Not Applicable",
        },
      ],
      oceanFreightTermsName: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid",
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect",
        },
      ],
      prepaidDetailsName: [
        {
          prepaidDetailsVal: "C_F",
          prepaidDetailsText: "C & F",
        },
        {
          prepaidDetailsVal: "CIF",
          prepaidDetailsText: "CIF",
        },
      ],
      collectDetailsName: [
        {
          collectDetailsVal: "Ex_Works",
          collectDetailsText: "Ex Works",
        },
        {
          collectDetailsVal: "FOB_Place_Of_Receipt",
          collectDetailsText: "FOB Place Of Receipt",
        },
        {
          collectDetailsVal: "FOB_Load_Port",
          collectDetailsText: "FOB Load Port",
        },
      ],
      showAdd: false,

      shipTypeList: [
        {
          shipTypeVal: "Origin",
          shipTypeText: "Origin",
        },
        {
          shipTypeVal: "Destination",
          shipTypeText: "Destination",
        },
      ],

      agentListName: [
        {
          agentNameVal: "agentName1",
          agentNameText: "agentName1",
        },
        {
          agentNameVal: "agentName2",
          agentNameText: "agentName2",
        },
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      allAgentColoader: [],
      CommodityAll: {},
      autoClientName: {},
      specialInstruction: "",
      ffExoprtDetail: {
        prbr_id:0,
        commodityRemarks: "",
        statusFinal: "",
        ffExportFclSeries: "",
        allModuleId: "0",
        ffExportFclId: "",
        containerId: "",
        portType: "",
        containerId: "",
        clientId: "",
        shippingId: "",
        shipType: "",
        coloaderName: "",
        shipmentType: "Sea_Shipment",
        transportType: "Export",
        stuffingType: "",
        containerInfo: "fcl",
        PORlocationId: "",
        LPlocationId: "",
        containerVolume: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        deliveryMode: "CY_CY",
        deliveryTerms: "",
        pdaDetail: "Shipper",
        oceanFreightTerms: "",
        prepaidDetails: "",
        collectDetails: "",
        freeTimeAtOrigin: "7",
        freeTimeAtDestination: "7",
        commodityId: "",
        commodityType: "",
        IMDGClass: "",
        commodityType: "",
        itemDescription: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        remark: "",
        shipType: "",
        agentName: "",
        buyer: "",
        buyingHouse: "",
        sourceOriginclientId: "",
        otherSpecify: "",
        specificAdditionalTask: "",
        ccType: "",
        ccCha: "",
        jobType: [],
        otherServices: [],
        additionalMoreTask: [],
        FFExportCreated: "",
        FFExportUpdated: "",
      },
      newJobType: [],

      deleteId: "",

      containerModal: {
        containerId: "",
        ffExportFclId: "",
        noOfContainer: "",
        containerTypeId: "",
      },
      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",
      transhipment: {
        transhipmentId: "",
        tentportId: "",
        ffExportFclId: "",
        tentPortName: "",
        estimateArrivalTime: "",
        estimateDepartureTime: "",
      },

      fobReceiptName: "",
      fobLoadPortName: "",
      allContainers: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      errorAtleastOne: "",

      ffExportError: [
        "Please Select Client Name",

        "Please Select Place of Receipt",
        "Please Select Load  Port Name",
        "Please Select Port  of Discharge",
        "Please Select final Delievery",
        "Please Select Commidity",
        "Please Select Stuffing type",
      ],
      ffExporterrorList: {
        clientId: "",

        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        commodityId: "",
        stuffingType: "",
      },

      ffExportCommodityError: ["Please Select Commidity"],
      ffExportCommodityerrorList: {
        commodityId: "",
      },

      ContainerError: ["Please Select Container", "Please Enter No of Container"],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: "",
      },

      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air_Shipment",
        },
      ],
      jobTypeSelectVal: false,
      otherServicesVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: [],
      getagentName: [],

      PortLoadList: [],
      getPortDischargeList: [],
      finalAllPlaceData: [],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      vgmBy: "",
      bookPageId: "",
      execPageId: "",
      vgmPageId: "",
      handoverPageId: "",
      sailPageId: "",
      ladingPageId: "",
      SUBSAlerts: [],
      viewPagePref: this.$sessionsStorage.get("user_view_page_pref"),
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    AddMessage,
    StatusAlerts,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffExoprtDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },
    shipmentTypeList() {
      return this.shipmentTypeName;
    },
    transportTypeList() {
      return this.transportTypeName;
    },

    stuffingTypeList() {
      return this.stuffingTypeName;
    },

    containerInfoList() {
      return this.containerInfoName;
    },

    deliveryModeList() {
      return this.deliveryModeName;
    },

    deliveryTermsList() {
      return this.deliveryTermsName;
    },

    pdaDetailList() {
      return this.pdaDetailsName;
    },
    oceanFreightTermsList() {
      return this.oceanFreightTermsName;
    },
    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },
  },
  methods: {
    gotToPage(ID) {
      if (ID == "BOOK") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);

        this.$router.push({
          path: "/freightForward/ffBooking",
        });
      } else if (ID == "EXEC") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        if (this.ffExoprtDetail.stuffingType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/ffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/newFFexecutionWareHouse",
          });
        }
      } else if (ID == "VGM") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        if (this.vgmBy == "SHIPPER") {
          if (this.ffExoprtDetail.stuffingType == "factoryStuffing") {
            this.$router.push({
              path: "/freightForward/ffExecution",
            });
          } else {
            this.$router.push({
              path: "/freightForward/newFFexecutionWareHouse",
            });
          }
        } else {
          this.$router.push({
            path: "/freightForward/newVgmDetail",
          });
        }
      } else if (ID == "HAND") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/handoverToRail",
        });
      } else if (ID == "SAIL") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/sailFPOD",
        });
      } else if (ID == "LADING") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/fclBLofLanding",
        });
      }
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              // console.log(self[vmodelArray]);
            }
          }
        });
      }
    },
    addMessage() {
      let data = {
        jobType: "1",
        typeOf: "7",
        allMessageId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: this.ffExoprtDetail.allModuleId,
        statusMain: this.ffExoprtDetail.statusFinal,
        client_id: this.ffExoprtDetail.clientId,
        pod_id: this.ffExoprtDetail.PODLocationId,
      };
      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));
      this.$router.push({
        path: "/UpdateMessage/allMessageForm",
      });
    },
    addStatus() {
      // alert(this.ffExoprtDetail.allModuleId);
      let data = {
        jobType: "1",
        typeOf: "7",
        allMessageId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: this.ffExoprtDetail.allModuleId,
        statusMain: this.ffExoprtDetail.statusFinal,
      };
      // console.log(data);
      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));
      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    methodsHere() {},
    showMultiple() {
      this.ffExoprtDetail.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getPortId1(item) {
      this.ffExoprtDetail.toportId = item.portId;
    },
    getPortId2(item) {
      this.ffExoprtDetail.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    // CommodityCallback(item) {
    //   this.ffExoprtDetail.commodityId = item.commodityId;
    //   // this.ffExoprtDetail.commodityType = item.commodityType;
    //   // this.ffExoprtDetail.itemDescription = item.itemDescription;
    // },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },
    deleteContainer(item) {
      this.deleteId = item.containerId;

      this.alert.content = "Are you sure you want to delete?";
      this.$refs["delete"].open();
    },
    deleteCon(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "frght_containers",
          tableId: "containerId",
          isActive: "isContainerActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => {});
      }
    },
    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.ffExoprtDetail.jobType = Array(this.showSegmentArray.length).fill(true);
          this.jobTypeSelectVal = true;
        } else {
          this.ffExoprtDetail.jobType = Array(this.showSegmentArray.length).fill(false);
          this.jobTypeSelectVal = false;
        }
      }
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
      }
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#FreghtContaner").DataTable();
    //   });
    // },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      Object.keys(this.ffExporterrorList).map((x, index) => {
        if (this.ffExoprtDetail[x] == "") {
          this.ffExporterrorList[x] = this.ffExportError[index];
          validate_new = false;
        }
      });

      if (this.commodityArray.length == 0) {
        this.errorAtleastOne = "Please select atleast one Container";
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.shippingId == "" &&
        this.ffExoprtDetail.containerInfo == "fcl"
      ) {
        $("#shippingId").focus();
        this.shippingIdError = "Select Shipping Line ";
        validate_new = false;
      }

      if (validate_new != true) {
        if (this.commodityArray.length > 0) {
          window.scroll(0, 40);
        }
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateFFExportCommodity() {
      let validate_new = true;

      Object.keys(this.ffExportCommodityerrorList).map((x, index) => {
        if (this.ffExoprtDetail[x] == "") {
          this.ffExportCommodityerrorList[x] = this.ffExportCommodityError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        if (this.commodityArray.length > 0) {
          window.scroll(0, 40);
        }
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFFExport() {
      let newVal = [];
      let newValOther = [];
      let newAdditionalTask = [];

      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newVal.push(x.value);
        }
      });
      this.showOtherServiceArray.map((x, index) => {
        if (this.ffExoprtDetail.otherServices[index] == true) {
          newValOther.push(x.value);
        }
      });

      this.ffExoprtDetail.additionalMoreTask.map((x, index) => {
        newAdditionalTask.push(x.value);
      });

      this.ffExoprtDetail["Otherservice1"] = newVal;
      this.ffExoprtDetail["ExtraWork"] = newValOther;
      this.ffExoprtDetail["additionalMoreTask"] = newAdditionalTask;

      // this.validateFFExport();
      // this.validateFFExportCommodity();
      // console.log("this.ffExportCommodityerrorList=>",this.ffExportCommodityerrorList);
      // return false;
      // alert(this.ffExoprtDetail.commodityId);
      if (this.ffExoprtDetail.commodityId == "" || this.ffExoprtDetail.commodityId == 0) {
        this.ffExportCommodityerrorList.commodityId = "Please Select Commidity";
        this.alert.content = "Please Select Commidity";
        this.$refs["addPop"].open();
        // this.validate =false;
        return false;
      }
      // alert(this.validate);
      if (this.validate != false) {
        $("#addButtonLoaderS").css("display", "none");
        $("#loaderS").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addffExportFcl.php`,
          data: JSON.stringify(this.ffExoprtDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editExportFCLId", data.Id);
              this.$sessionsStorage.set("editFFBookingId", data.bookingId);
              this.$sessionsStorage.set("editFFExecutionId", this.ExecutionDisable);
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");

              if (this.ffExoprtDetail.ffExportFclId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.$refs["addPop11212"].open();
            }
          })
          .catch((error) => {});
      }
    },
    onClose11212() {
      if (this.ffExoprtDetail.containerInfo == "lcl") {
        if (this.ffExoprtDetail.portType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/ffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/ffexecutionWareHouse",
          });
        }
      } else {
        this.$router.push({
          path: "/freightForward/ffBooking",
        });
      }
    },
    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addFFContainers() {
      this.doLoading();
      if (this.ffExoprtDetail.ffExportFclId != "") {
        this.containerModal["ffExportFclId"] = this.ffExoprtDetail.ffExportFclId;
      } else {
        this.containerModal["ffExportFclId"] = "";
      }

      let arrayNew = this.commodityArray.filter((x) => {
        return x.containerTypeId == this.containerModal.containerTypeId;
      });
      if (arrayNew.length > 0) {
        this.alert.content = arrayNew[0].containerType + " Already Exist";
        this.$refs["addPop"].open();
        this.containerModal.containerTypeId = "";
        return false;
      }

      this.validateFFContainer();
      if (this.validate != false) {
        $("#addButtonLoaderC").css("display", "none");
        $("#loaderC").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addFFContainers.php`,
          data: JSON.stringify(this.containerModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoaderC").css("display", "block");
              $("#loaderC").css("display", "none");
              this.ffExoprtDetail.containerId += data.Id + ",";

              this.containerModal.containerTypeId = "";
              this.containerTypeIdError = "";
              this.containerModal.noOfContainer = "";
              this.noOfContainerError = "";

              this.onClose22();
              this.doLoadingClose();
            }
          })
          .catch((error) => {});
      }
    },
    onClose22() {
      this.commodityArray = [];
      let payload = {
        containerId: this.ffExoprtDetail.containerId,
      };

      if (this.ffExoprtDetail.ffExportFclId != "") {
        payload["ffExportFclId"] = this.ffExoprtDetail.ffExportFclId;
      } else {
        payload["ffExportFclId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFFContainers.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            let totalContainer = data.itemArray;
            if (data.itemArray.length > 0) {
              this.commodityArray = data.itemArray;
            }

            this.totalContainer = 0;
            this.commodityArray.map((x, index) => {
              this.totalContainer =
                parseFloat(x.noofContainer) + parseFloat(this.totalContainer);
            });
            this.getData();
          }
        })
        .catch((error) => {});
    },
    getData() {
      let array = [];
      let array1 = [];
      let arrayAdditional = [];
      this.doLoading();
      let vehicle_drive = {
        itemCode: "itemCode",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFFExport_NewV3.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData.filter((x) => {
                return x.categoryType == "Agent";
              });

              this.getColoaderName = data.agentColoaderData.filter((x) => {
                return x.categoryType == "CoLoader";
              });
            }
            if (data.CommodityData_new.length > 0) {
              // this.getCommodityData = data.CommodityData;
              this.getCommodityData = data.CommodityData_new;
            } else {
              this.getCommodityData = [];
            }
            if (data.containerArry.length > 0) {
              this.allContainers = data.containerArry;

              this.totalContainer = 0;
              this.allContainers.map((x, index) => {
                this.totalContainer =
                  parseFloat(x.noofContainer) + parseFloat(this.totalContainer);
              });
            } else {
              this.allContainers = [];
            }
            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            } else {
              this.getCLientData = [];
            }
            //    console.log(data, "ghjkl");
            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            } else {
              this.getShippingLineData = [];
            }

            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (
              this.$sessionsStorage.get("editExportFCLId") != "" &&
              this.$sessionsStorage.get("editExportFCLId") != undefined
            ) {
              let array_new = this.getCommodityData;
              this.CommodityAll = array_new.filter((x) => {
                return x.commodityId == data.editFFEX[0].commodityId;
              })[0];

              this.ExecutionDisable = data.ffExecutionId;
              this.vgmBy = data.vgmBy;

              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExoprtDetail[x] = data.editFFEX[0][x] || "";
                if (x == "jobType") {
                  if (data.editFFEX[0][x]) {
                    array = data.editFFEX[0][x].split(",");
                  }
                }
                if (x == "otherServices") {
                  if (data.editFFEX[0][x]) {
                    array1 = data.editFFEX[0][x].split(",");
                  }
                }
                if (x == "moreAdditionalTask") {
                  if (data.editFFEX[0][x]) {
                    arrayAdditional = data.editFFEX[0][x].split(",");
                  }
                }
              });

              this.ffExoprtDetail["jobType"] = [];
              this.ffExoprtDetail["otherServices"] = [];
              this.ffExoprtDetail["additionalMoreTask"] = [];

              this.showAdditionalMoreTaskArray.map((x, index) => {
                let i = arrayAdditional.indexOf(x.value);

                i >= 0 ? this.ffExoprtDetail.additionalMoreTask.push(x) : "";
              });

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.jobType[index] = true)
                  : (this.ffExoprtDetail.jobType[index] = false);
              });

              this.showOtherServiceArray.map((x, index) => {
                let i = array1.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.otherServices[index] = true)
                  : (this.ffExoprtDetail.otherServices[index] = false);
              });

              this.ffExoprtDetail.containerId += ",";
              this.showFFContainer(this.ffExoprtDetail.containerId);
              if (data.editFFEX[0]["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            this.bookPageId = data.SEA_FRGHT_Booking;
            this.execPageId = data.SEA_FRGHT_EXEC;
            this.vgmPageId = data.SEA_FRGHT_VGM;
            this.handoverPageId = data.SEA_FRGHT_RAIL;
            this.sailPageId = data.SEA_FRGHT_SAIL;
            this.ladingPageId = data.SEA_FRGHT_BLADING;
            this.getTrackingDetails();
            this.doLoadingClose();
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.ffExoprtDetail.allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
              this.getSingleSubscriptionsFunc(this.trackingId);
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch((error) => {});
    },

    async getSingleSubscriptionsFunc(trackingId) {
      this.SUBSAlerts = [];
      let payload = {};
      this.getSingleSubscriptions = {};
      payload = {
        itemCode: "getSingleSubscriptions",
        subscription_id: trackingId,
      };

      payload = JSON.stringify(payload);

      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getSingleSubscriptions) {
              if (data.getSingleSubscriptions.containershipments.length > 0) {
                data.getSingleSubscriptions.containershipments.forEach(
                  (element, index) => {
                    if (element) {
                      if (element.pod_timeofarrival_warning) {
                        let type;
                        if (
                          element.pod_timeofarrival_warning.risk == 2 ||
                          element.pod_timeofarrival_warning.risk_verbose == "High Risk"
                        ) {
                          type = "alert-danger-text";
                        }
                        if (
                          element.pod_timeofarrival_warning.risk_verbose == "Low Risk"
                        ) {
                          type = "alert-warning";
                        }
                        if (element.pod_timeofarrival_warning.risk_verbose == "No Risk") {
                          type = "alert-info-text";
                        }
                        this.SUBSAlerts.push(
                          {
                            id: element.pod_timeofarrival_warning.risk,
                            ContainerNO: element.container_number,
                            ContainerType: element.container_type_iso,
                            type: type,
                            risk_verbose: element.pod_timeofarrival_warning.risk_verbose,
                            title: element.pod_timeofarrival_warning.risk_verbose,
                            message:
                              "Container No : " +
                              element.container_number +
                              " " +
                              element.pod_timeofarrival_warning.risk_description,
                            conclusion: element.pod_timeofarrival_warning.conclusion,
                          },
                          {
                            id: element.pod_timeofarrival_warning.risk + 1,
                            type: "alert-info-text",
                            risk_verbose: element.pod_timeofarrival_warning.risk_verbose,
                            title: "Conclusion",
                            ContainerNO: element.container_number,
                            ContainerType: element.container_type_iso,
                            message: element.pod_timeofarrival_warning.conclusion,
                            conclusion: element.pod_timeofarrival_warning.conclusion,
                          }
                        );
                      }
                    }
                  }
                );
              }
            }
            console.log("SUBSAlerts PS =>", this.SUBSAlerts);
          }
        })
        .catch((error) => {
          console.log("Catch on getSingleSubscriptions Error: ", error);
        });
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    // viewEditFFExport() {
    //   let array = [];
    //   let array1 = [];
    //   let arrayAdditional = [];
    //   let edit_SE = {
    //     editFFEX: "editFFEX",
    //     ffExportFclId: this.$sessionsStorage.get("editExportFCLId")
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_FFSeaExport/viewEditFFExport.php`,
    //     data: JSON.stringify(edit_SE),

    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId")
    //     }
    //   };

    //   axios(options)
    //     .then(result => {
    //       const { statusText, status, data } = result;

    //       if ( status == 200 && data) {
    //         let array_new = this.getCommodityData;
    //         this.CommodityAll = array_new.filter(x => {
    //           return x.commodityId == data.editFFEX[0].commodityId;
    //         })[0];

    //         this.ExecutionDisable = data.ffExecutionId;

    //         Object.keys(data.editFFEX[0]).map(x => {
    //           this.ffExoprtDetail[x] = data.editFFEX[0][x] || "";
    //           if (x == "jobType") {
    //             array = data.editFFEX[0][x].split(",");
    //           }
    //           if (x == "otherServices") {
    //             array1 = data.editFFEX[0][x].split(",");
    //           }
    //           if (x == "moreAdditionalTask") {
    //             arrayAdditional = data.editFFEX[0][x].split(",");
    //           }
    //         });

    //         this.ffExoprtDetail["jobType"] = [];
    //         this.ffExoprtDetail["otherServices"] = [];
    //         this.ffExoprtDetail["additionalMoreTask"] = [];

    //         this.showAdditionalMoreTaskArray.map((x, index) => {
    //           let i = arrayAdditional.indexOf(x.value);

    //           i >= 0 ? this.ffExoprtDetail.additionalMoreTask.push(x) : "";
    //         });

    //         this.showSegmentArray.map((x, index) => {
    //           let i = array.indexOf(x.value);

    //           i >= 0
    //             ? (this.ffExoprtDetail.jobType[index] = true)
    //             : (this.ffExoprtDetail.jobType[index] = false);
    //         });

    //         this.showOtherServiceArray.map((x, index) => {
    //           let i = array1.indexOf(x.value);

    //           i >= 0
    //             ? (this.ffExoprtDetail.otherServices[index] = true)
    //             : (this.ffExoprtDetail.otherServices[index] = false);
    //         });

    //         this.ffExoprtDetail.containerId += ",";
    //         this.showFFContainer(this.ffExoprtDetail.containerId);
    //       }
    //     })
    //     .catch(error => {});
    // },
    showFFContainer(Trid) {
      this.commodityArray = [];

      let payload = {
        containerId: Trid,
        ffExportFclId: "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFFContanerTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.ContainerArrayDetails.length > 0) {
              this.commodityArray = data.ContainerArrayDetails;
            }
            this.totalContainer = 0;
            this.commodityArray.map((x, index) => {
              this.totalContainer =
                parseFloat(x.noofContainer) + parseFloat(this.totalContainer);
            });

            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/freightForward/ViewffExportFcl"
      // });
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20",
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
      this.showOtherServiceArray = [
        {
          value: "Marking",
          show: "Marking/Labelling",
          flex: "15",
        },
        {
          value: "Palletization",
          show: "Palletization",
          flex: "15",
        },
        {
          value: "Fumigation",
          show: "Fumigation",
          flex: "15",
        },

        {
          value: "Lashing",
          show: "Lashing/Choking",
          flex: "15",
        },
        {
          value: "Legalization",
          show: "Legalization",
          flex: "15",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
          flex: "15",
        },
        {
          value: "Phyto",
          show: "Phyto",
          flex: "15",
        },

        {
          value: "APEDA",
          show: "APEDA",
          flex: "15",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
          flex: "15",
        },

        {
          value: "WildlifeNOC",
          show: "Wildlife NOC",
          flex: "15",
        },
        {
          value: "Insurance",
          show: "Insurance",
          flex: "15",
        },
        // {
        //   value: "OthersSpecify",
        //   show: " Others Specify",
        //      flex: "15"
        // },
        {
          value: "None",
          show: "None",
          flex: "15",
        },
      ];

      this.showAdditionalMoreTaskArray = [
        {
          value: "Legalization",
          show: "Legalization",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
        },
        {
          value: "Phyto",
          show: "Phyto",
        },

        {
          value: "APEDA",
          show: "APEDA",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
        },

        {
          value: "WildlifeNOC",
          show: "Wildlife NOC",
        },
        {
          value: "Insurance",
          show: "Insurance",
        },
        {
          value: "OthersSpecify",
          show: " Others Specify",
        },
      ];
    },

    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              // alert(data.find);

              if (data.commodityNewId != "" && data.commodityNewId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              console.log("MyData=>", data);
              console.log("Mystatus=>", status);
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newFFExportFcl.vue?7d8b8ff6